import React from "react";
import {Accordion, AccordionDetails, AccordionSummary, Grid2} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import FilmReleaseStatisticsForm from "./FilmReleaseStatisticsForm";
import FilmReleaseStatisticsChart from "./FilmReleaseStatisticsChart";

export default function FilmReleaseStatistics() {
    return (
        <Grid2 container direction={"column"} spacing={3}>
            <Grid2 size={12}>
                <Accordion defaultExpanded>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                        Search
                    </AccordionSummary>
                    <AccordionDetails>
                        <FilmReleaseStatisticsForm />
                    </AccordionDetails>
                </Accordion>
            </Grid2>
            <Grid2 size={12}>
                <FilmReleaseStatisticsChart />
            </Grid2>
        </Grid2>
    );
}
